module.exports = __webpack_public_path__ + "static/media/tr.f2343de0.svg";